// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-view.is-fullscreen .map-left-sidebar .map-sidebar{z-index:102}.map-view.is-fullscreen .map{height:100%}.map-view .map-sidebar.is-right{width:280px;margin-right:-300px}.alex-map,.alex-map .alex-map-angular,.alex-map .map-container{height:100%}.alex-map .map{height:800px;border:none;margin:0;display:block;position:relative;min-height:auto}@media(max-width:740px){.alex-map .map{max-height:90vh}}", ""]);
// Exports
module.exports = exports;
